import { createContext, useContext } from 'react';
export const Context = createContext({
    actors: {},
    isSubmitting: false,
    isValidating: false,
    submit: () => { }
});
export const { Consumer, Provider } = Context;
/**
 * This is an internal hook used by `<XForm />`. It returns XForm's React.Context
 *
 * @returns ContextValues
 */
const useXForm = () => {
    return useContext(Context);
};
export default useXForm;
